import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    CANCEL_OVERRIDE_SUCCESS,
    CANCEL_OVERRIDE_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* cancelOverrideSaga(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/priceOverride/cancel`;

    try {
        const response = yield axios
            .post(url, action.payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => res.data);

        yield put({ type: CANCEL_OVERRIDE_SUCCESS, data: response });
    } catch (error) {
        yield put({
            type: CANCEL_OVERRIDE_FAILURE,
            data: { statusCode: error?.response?.status, statusMessage: error?.message },
        });
        errorHandler(error);
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
    }
}
